var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCellPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1215 2.00047H9.91736C9.53563 1.99354 9.15636 2.06318 8.80184 2.2053C8.44732 2.34742 8.1247 2.55916 7.85292 2.82807C7.58114 3.09699 7.36569 3.41766 7.21923 3.77125C7.07277 4.12484 6.99824 4.50421 7.00003 4.88709V23H23V4.88709C23.0017 4.50753 22.9284 4.1314 22.7844 3.7804C22.6403 3.4294 22.4284 3.1105 22.1607 2.84211C21.8931 2.57371 21.5751 2.36115 21.2251 2.2167C20.8751 2.07224 20.5 1.99875 20.1215 2.00047Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48649 2.97297C8.6506 2.97297 7.97297 3.6506 7.97297 4.48649V25.5135C7.97297 26.3494 8.6506 27.027 9.48649 27.027H20.1622C20.9981 27.027 21.6757 26.3494 21.6757 25.5135V4.48649C21.6757 3.6506 20.9981 2.97297 20.1622 2.97297H9.48649ZM5 4.48649C5 2.00867 7.00867 0 9.48649 0H20.1622C22.64 0 24.6486 2.00867 24.6486 4.48649V25.5135C24.6486 27.9913 22.64 30 20.1622 30H9.48649C7.00867 30 5 27.9913 5 25.5135V4.48649Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7253 23.3108C10.7253 22.7635 11.169 22.3198 11.7163 22.3198H17.946C18.4933 22.3198 18.937 22.7635 18.937 23.3108C18.937 23.8581 18.4933 24.3018 17.946 24.3018H11.7163C11.169 24.3018 10.7253 23.8581 10.7253 23.3108Z",
    fill: "#3D0E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.838 6.6892C15.4127 6.6892 15.8785 6.22333 15.8785 5.64866C15.8785 5.07398 15.4127 4.60812 14.838 4.60812C14.2633 4.60812 13.7975 5.07398 13.7975 5.64866C13.7975 6.22333 14.2633 6.6892 14.838 6.6892Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCellPhone);
export default __webpack_public_path__ + "static/media/ic_cell_phone.ccaa5220e96d01729d0dc343690d95b2.svg";
export { ForwardRef as ReactComponent };